import React from "react";
import { TextWrapper } from "./MarketingTextSlogan.styles";
import { Body } from "../Typography";
import { HomepageVariantCustomH2 } from "../../pagelayouts/homepage/HomepagePageLayout.styles";

interface MarketingTextSloganProps {
    text: string | JSX.Element;
    homepageVariant?: boolean;
}

export const MarketingTextSlogan = ({ text, homepageVariant = false }: MarketingTextSloganProps) => {
    const Component: any = homepageVariant ? HomepageVariantCustomH2 : Body;

    return (
        <TextWrapper homepageVariant={homepageVariant}>
            <div>
                <img src="/authory_static_files/images/menu-icons/heart.svg" />
            </div>
            <div>
                <Component>{text}</Component>
            </div>
        </TextWrapper>
    );
};
